<template>
	<v-dialog v-model="isVisible" max-width="600">
		<p-card class="tw-p-none overflow-hidden">
			<p-header-dialog :negative-margin="false" @closeClicked="close()">
				SubFactor
			</p-header-dialog>
			<section class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-p-4">
				<input
					class="subfactor-section--row-input tw-w-full"
					placeholder="Descripción"
					v-model="subFactor.description"
				/>
			</section>
			<p-horizontal-divider></p-horizontal-divider>
			<div class="tw-flex tw-justify-center tw-items-center tw-pb-4">
				<p-button
					:disabled="fieldsNone"
					type="primary"
					@click="saveNewItem"
					> Guardar
				</p-button>
			</div>
		</p-card>
	</v-dialog>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import CloseIcon from '@/modules/shared/components/icons/close-icon';
import PButton from '@/modules/shared/components/ui/p-button';
import PHeaderDialog from '@/modules/shared/components/ui/dialog/p-header-dialog';

export default {
	name: 'add-subfactor-dialog',
	created() {
	},
	data() {
		return {
			isVisible: false,
			subFactor: {
				description: null,
				score: null,
				code: null,
			},
		};
	},
	components: { PHeaderDialog, PButton, CloseIcon, PCard, PHorizontalDivider },
	methods: {
		open() {
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
		},
		saveNewItem() {
			if (!this.flagEditItem) {
				this.subFactor.score = null;
				this.subFactor.code = null;
				this.subFactor.questions = [];
				this.subFactor.equivalences = [
					{
						code: 'NA',
						description: 'No Aceptable',
						value: null,
					},
					{
						code: 'Bx',
						description: 'Bajo el Promedio',
						value: null,
					},
					{
						code: 'Sx',
						description: 'Superior al Promedio',
						value: null,
					},
					{
						code: 'Ex',
						description: 'Excelente',
						value: null,
					},
				];
				this.$emit('handlerItem', this.subFactor);
			}
			this.close();
		},
	},
	computed: {
		fieldsNone() {
			return !this.subFactor.description;
		},
	},
	props: {
		selectedSubFactor: {
			type: Object,
			default: () => {},
		},
		flagEditItem: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		selectedSubFactor: {
			handler(newVal) {
				this.subFactor = newVal;
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.subfactor-section--row {
	&-input {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, green-dark);
		border-radius: 4px;
		display: block;
		outline: none;
		color: map-get($colors, gray-sidebar);
		padding: 5px 20px;

		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/recruitment/components/content/add-subfactor-dialog.vue